function PiaSuccess() {
  this.init = function (urlParams) {
    return {
      signedDocumentId: urlParams.signedDocumentId,
      executionDate: urlParams.executionDate
    }
  }
}